import React, { useEffect, useState } from "react";
import { Dropdown, Menu, Tag } from "antd";
import { useTranslation } from "react-i18next";

const Language = () => {
	const { i18n } = useTranslation();
	const [lang, setLang] = useState("");
	const { t } = useTranslation();

	useEffect(() => {
		const curLang = localStorage.getItem("i18nextLng");
		switch (curLang) {
			case "ru":
				setLang("Русский");
				break;
			case "uz":
				setLang("Ўзбекча");
				break;
			case "lat":
				setLang("O'zbekcha");
				break;
			default:
				setLang("Ўзбекча");
		}
	});

	const changeLang = (e: string) => {
		i18n.changeLanguage(e);
	};

	return (
		<div>
			<Dropdown
				menu={{
					items: [
						{
							key: "lat",
							label: <p onClick={() => changeLang("lat")}>O'zbekcha</p>
						},
						{
							key: "uz",
							label: <p onClick={() => changeLang("uz")}>Ўзбекча</p>
						},
						{
							key: "ru",
							label: <p onClick={() => changeLang("ru")}>Русский</p>
						}
					]
				}}>
				<Tag style={{ width: "70px", textAlign: "center", cursor: "pointer" }} color="blue">
					{lang}
				</Tag>
			</Dropdown>
		</div>
	);
};

export default Language;
